import React from "react";

/**
 * StaticMap — decorative dark-themed map.
 * - `mode="pins"` (default): precise gold pin markers (used only AFTER purchase / admin views).
 * - `mode="approximate"`: translucent gold circular areas — never reveals exact position. Used pre-purchase.
 * - `showLegend`: adds a small pill top-left describing the approximate treatment.
 */
export default function StaticMap({
  pins = [],
  height = 480,
  activeId = null,
  onPinClick = () => {},
  showUSOutline = true,
  overlay = null,
  className = "",
  mode = "pins",
  showLegend = false,
}) {
  return (
    <div
      className={`sb-map w-full relative ${className}`}
      style={{ height }}
      data-testid="static-map"
    >
      {showUSOutline && (
        <svg
          viewBox="0 0 1000 500"
          className="absolute inset-0 w-full h-full opacity-40"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            d="M120,230 L180,180 L260,170 L340,190 L420,175 L500,180 L580,170 L660,175 L730,190 L800,210 L860,230 L890,270 L870,310 L820,340 L760,360 L680,370 L600,375 L520,380 L440,375 L360,370 L280,355 L200,335 L150,300 L120,270 Z"
            fill="rgba(255,193,7,0.05)"
            stroke="rgba(255,193,7,0.35)"
            strokeWidth="1.5"
          />
          <path
            d="M120,230 L180,180 L260,170 L340,190 L420,175 L500,180 L580,170 L660,175 L730,190 L800,210 L860,230"
            fill="none"
            stroke="rgba(255,193,7,0.15)"
            strokeWidth="1"
          />
          <ellipse cx="580" cy="215" rx="35" ry="15" fill="#080B0D" opacity="0.9" />
          <ellipse cx="620" cy="225" rx="20" ry="10" fill="#080B0D" opacity="0.9" />
        </svg>
      )}

      {showLegend && (
        <div className="absolute top-3 left-3 z-20 sb-pill sb-pill-gold" style={{ backdropFilter: "blur(6px)" }}>
          Approximate Locations Only — exact address unlocks after purchase
        </div>
      )}

      {pins.map((p) => {
        if (mode === "approximate") {
          return (
            <button
              key={p.id}
              onClick={() => onPinClick(p.id)}
              data-testid={`map-pin-${p.id}`}
              aria-label={`Approximate opportunity area ${p.id}`}
              className="absolute z-10 transition-transform hover:scale-110"
              style={{ left: p.left, top: p.top, transform: "translate(-50%, -50%)" }}
            >
              <span
                className="block rounded-full"
                style={{
                  width: activeId === p.id ? 110 : 88,
                  height: activeId === p.id ? 110 : 88,
                  background: "radial-gradient(circle, rgba(255,193,7,0.28) 0%, rgba(255,193,7,0.12) 55%, rgba(255,193,7,0.03) 100%)",
                  border: `1px solid ${activeId === p.id ? "rgba(255,193,7,0.9)" : "rgba(255,193,7,0.55)"}`,
                  boxShadow: activeId === p.id ? "0 0 0 6px rgba(255,193,7,.10), 0 8px 24px rgba(0,0,0,.5)" : "0 4px 14px rgba(0,0,0,.4)",
                }}
              />
            </button>
          );
        }
        return (
          <button
            key={p.id}
            onClick={() => onPinClick(p.id)}
            data-testid={`map-pin-${p.id}`}
            className="absolute z-10 transition-transform hover:scale-125"
            style={{ left: p.left, top: p.top, transform: "translate(-50%, -100%)" }}
            aria-label={`Opportunity ${p.id}`}
          >
            <div
              className="sb-pin"
              style={{
                boxShadow:
                  activeId === p.id
                    ? "0 0 0 4px rgba(255,193,7,.35), 0 6px 16px rgba(0,0,0,.7)"
                    : undefined,
              }}
            />
          </button>
        );
      })}
      {overlay}
    </div>
  );
}
